import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Único ponto de resolução de conflito entre classes Tailwind (Playbook §
 * Pilha de referência). Todo componente de `ui/` compõe className por aqui.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
